import { colors } from 'theme'

export const defaultThemeStyles = {
    textMain: colors.blackLight,
    textSub: colors.grey,
    textError: colors.errorLight,
    textPromo: colors.blackLight,
}
